import { render, staticRenderFns } from "./campaign-ivr-step.vue?vue&type=template&id=3c230223"
import script from "./campaign-ivr-step.vue?vue&type=script&lang=js"
export * from "./campaign-ivr-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports